import { Dialog, GemNumber, Image } from "@onmo/ui";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import { removePopupQueue } from "../../../slices/popup";
import { PopupType } from "../../../constants/popup";
import HeartMonoIcon from "../../../assets/result/heart_mono_1x.webp";
import HeartMonoIcon2x from "../../../assets/result/heart_mono_2x.webp";
import HeartMonoIcon3x from "../../../assets/result/heart_mono_3x.webp";
import { useTranslation } from "react-i18next";

type IGamesLosePopup = {
  onCancel: () => void;
  onContinue: () => void;
};

const GameLosePopup: React.FC<IGamesLosePopup> = (props) => {
  const dispatch = useAppDispatch();
  const { onCancel, onContinue } = props;
  const { currentPopupId } = useAppSelector((state) => state.popup);
  const { t } = useTranslation();

  const onClickClose = () => {
    dispatch(removePopupQueue({ type: PopupType.GameLose }));
    onCancel();
  };

  const onClickContinue = () => {
    dispatch(removePopupQueue({ type: PopupType.GameLose }));
    onContinue();
  };

  return (
    <Dialog
      open={currentPopupId === PopupType.GameLose}
      mainAction={{
        text: (
          <>
            {t("buy")} <GemNumber amount={1} />
          </>
        ),
        onClick: onClickContinue,
      }}
      secondAction={{
        text: t("cancel"),
        onClick: onClickClose,
      }}
      icon={
        <Image
          src={HeartMonoIcon}
          src2x={HeartMonoIcon2x}
          src3x={HeartMonoIcon3x}
        />
      }
      title={t("boost_your_game")}
      description={t("purchase_for_keeping_action_going")}
    />
  );
};
export default GameLosePopup;
